if (!customElements.get('cb-instagram-desk')) {
  customElements.define('cb-instagram-desk', class extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('[data-cb-ig-cap]').forEach((el) => {
        el.textContent = el.textContent.replace(/[\p{Extended_Pictographic}‍️]/gu, '').replace(/\s+/g, ' ').trim();
      });
      this.setupTilt();
      this.cam = this.querySelector('[data-cb-ig-cam]');
      this.shot = this.querySelector('[data-cb-ig-new]');
      if (matchMedia('(prefers-reduced-motion: reduce)').matches || !this.shot) { this.cam.style.display = 'none'; return; }
      this.classList.add('is-js', 'is-scene');
      this.spacer = this.querySelector('.cb-ig__spacer');
      this.flash = this.querySelector('.cb-ig__flash');
      this.newTag = this.shot.querySelector('.cb-ig__new');
      this.dev = this.shot.querySelector('.cb-ig__dev');
      this.tone = this.shot.querySelector('.cb-ig__tone');
      this.header = document.querySelector('.header__outer-wrapper');
      this.cam.addEventListener('click', () => this.replay());

      this.io = new IntersectionObserver((es) => {
        if (!es.some((x) => x.isIntersecting)) return;
        this.io.disconnect();
        this.classList.add('is-on');
      }, { threshold: 0.2 });
      this.io.observe(this);

      this.onScroll = () => { if (!this.raf) this.raf = requestAnimationFrame(() => { this.raf = 0; this.tick(); }); };
      this.onResize = () => { this.geo = null; this.onScroll(); };
      // Listen to scroll only while the scene is within one screen of the viewport
      this.near = new IntersectionObserver(([e]) => {
        if (e.isIntersecting) {
          addEventListener('scroll', this.onScroll, { passive: true });
          addEventListener('resize', this.onResize, { passive: true });
          this.geo = null;
        } else {
          removeEventListener('scroll', this.onScroll);
          removeEventListener('resize', this.onResize);
        }
        this.tick();
      }, { rootMargin: '100% 0px' });
      this.near.observe(this);
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this.near) this.near.disconnect();
      removeEventListener('scroll', this.onScroll);
      removeEventListener('resize', this.onResize);
    }

    measure() {
      const el = this.shot, cam = this.cam;
      const slotY = cam.offsetTop + cam.offsetHeight * 0.86;
      this.geo = {
        r: parseFloat(getComputedStyle(el).getPropertyValue('--r')) || 0,
        dx: cam.offsetLeft + cam.offsetWidth / 2 - (el.offsetLeft + el.offsetWidth / 2),
        hideY: slotY - el.offsetHeight - el.offsetTop,
        hangY: slotY - el.offsetTop
      };
    }

    // Scene progress 0..1: how far the page has scrolled while the scene is pinned.
    progress() {
      const top = this.header ? Math.max(0, this.header.getBoundingClientRect().bottom) : 0;
      if (top !== this.pinTop) { this.pinTop = top; this.style.setProperty('--cb-ig-top', top + 'px'); }
      const run = this.spacer.offsetHeight || 1;
      return Math.min(1, Math.max(0, (top - this.getBoundingClientRect().top) / run));
    }

    tick() {
      let p = this.done ? 1 : this.progress();
      if (p >= 1 && !this.done) this.done = true;
      if (this.done && !this.collapsed) {
        const r = this.getBoundingClientRect();
        if (r.bottom < 0 || r.top > innerHeight || scrollY < this.lastY) this.collapse();
      }
      this.lastY = scrollY;
      if (this.replayAt) {
        const q = 0.12 + (performance.now() - this.replayAt) / 3500 * 0.88;
        if (q >= 1) this.replayAt = 0; else { p = q; this.onScroll(); }
      }
      this.paint(p);
    }

    // Scene played once: drop the pin and the extra scroll room, keeping the view in place.
    collapse() {
      this.collapsed = true;
      const pin = this.querySelector('.cb-ig__pin');
      const html = document.documentElement;
      const before = pin.getBoundingClientRect().top;
      html.style.overflowAnchor = 'none';
      this.classList.add('is-done');
      const shift = pin.getBoundingClientRect().top - before;
      if (shift) scrollBy(0, shift);
      requestAnimationFrame(() => { html.style.overflowAnchor = ''; });
    }

    paint(p) {
      if (!this.geo) this.measure();
      const g = this.geo;
      const seg = (a, b) => Math.min(1, Math.max(0, (p - a) / (b - a)));
      const ease = (t) => 1 - Math.pow(1 - t, 3);
      const lerp = (a, b, t) => a + (b - a) * t;

      this.cam.style.transform = 'translateY(' + ((1 - ease(seg(0, 0.12))) * -110) + '%)';
      const f = seg(0.12, 0.16) - seg(0.16, 0.24);
      this.flash.style.opacity = (f * 0.85).toFixed(3);
      this.classList.toggle('is-flash', f > 0.3);

      const e = ease(seg(0.16, 0.45)), l = ease(seg(0.66, 0.9));
      const x = lerp(g.dx, 0, l), y = lerp(lerp(g.hideY, g.hangY, e), 0, l), rot = lerp(0, g.r, l);
      this.shot.style.visibility = p >= 0.12 ? 'visible' : 'hidden';
      this.shot.style.transform = 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px) rotate(' + rot.toFixed(2) + 'deg)';
      this.shot.style.zIndex = p >= 0.12 && p < 1 ? 25 : '';
      this.dev.style.opacity = (1 - seg(0.3, 0.6)).toFixed(3);
      this.tone.style.opacity = (0.55 * (1 - seg(0.4, 0.66))).toFixed(3);
      if (this.newTag) this.newTag.style.transform = 'rotate(8deg) scale(' + ease(seg(0.9, 0.98)).toFixed(3) + ')';
    }

    replay() {
      if (!this.done) return;
      this.replayAt = performance.now();
      this.onScroll();
    }

    setupTilt() {
      if (!matchMedia('(hover: hover) and (pointer: fine) and (min-width: 900px)').matches) return;
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.querySelectorAll('.cb-ig__pr').forEach((pr) => {
        const t = pr.querySelector('.cb-ig__tilt');
        pr.addEventListener('pointermove', (ev) => {
          const b = pr.getBoundingClientRect();
          const px = (ev.clientX - b.left) / b.width, py = (ev.clientY - b.top) / b.height;
          t.style.setProperty('--rx', ((0.5 - py) * 16).toFixed(1) + 'deg');
          t.style.setProperty('--ry', ((px - 0.5) * 18).toFixed(1) + 'deg');
          t.style.setProperty('--gx', ((px - 0.5) * 50).toFixed(1) + '%');
          t.style.setProperty('--gy', ((py - 0.5) * 50).toFixed(1) + '%');
        });
        pr.addEventListener('pointerleave', () => {
          ['--rx', '--ry', '--gx', '--gy'].forEach((v) => t.style.removeProperty(v));
        });
      });
    }
  });
}
